import type { ReactNode } from 'react';
import styles from './sort-section.module.scss';
const SortAndResultsSection = ({ children }: IProps) => {
	return <div className={styles.wrapper}>{children}</div>;
};

export interface IProps {
	children: ReactNode;
}
export default SortAndResultsSection;
